module.exports = __webpack_public_path__ + "static/media/background-level-passed.ad4fc34e.png";